module.exports = __webpack_public_path__ + "static/virus-sms-b09994f9b71d5f472109b8ec05e01364.mp4";